import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { cn } from "../lib/utils";

/**
 * Phase 149 — tiny "Live" pill shown beside page titles whose collection figures refresh themselves
 * (see lib/liveCollections.js). Purely informational.
 */
export const LiveBadge = ({ className, label = "Live", testId = "live-collections-badge" }) => (
  <TooltipProvider delayDuration={200}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span data-testid={testId}
          className={cn("inline-flex items-center gap-1.5 rounded-full border border-border bg-background/80 px-2 py-0.5",
            "text-[11px] font-medium text-muted-foreground select-none", className)}>
          <span className="relative flex h-2 w-2" aria-hidden="true">
            <span className="absolute inline-flex h-full w-full rounded-full bg-[hsl(var(--success))] opacity-60 animate-ping" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-[hsl(var(--success))]" />
          </span>
          {label}
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-xs text-xs">
        Collection figures refresh automatically — every 20 seconds and whenever you return to this tab — so a payment
        recorded anywhere shows up here without reloading.
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
